/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

App.ready(() => App.settings.init());

App.settings = {
  init() {

    $(document)
      .off("click", ".js-btn-toggle-panel", App.settings.toggle_panel)
      .on("click", ".js-btn-toggle-panel", App.settings.toggle_panel)

      .off("click", ".js-sidebar-accounts-toggle, .js-sidebar-accounts-list a", App.settings.toggle_accounts)
      .on("click", ".js-sidebar-accounts-toggle, .js-sidebar-accounts-list a", App.settings.toggle_accounts)

      .off("click", ".js-settings-accounts-toggle", App.settings.toggle_settings_accounts)
      .on("click", ".js-settings-accounts-toggle", App.settings.toggle_settings_accounts)

      .off("click", App.settings.close_accounts)
      .on("click", App.settings.close_accounts);

    return this.check_for_anchor();
  },

  check_for_anchor() {
    if (/panel:/.test(location.hash)) {
      const panel = location.hash.split(":")[1];
      return $(`#${panel}`).addClass("open");
    }
  },

  close_accounts(evt) {
    if (!$(evt.target).is(".js-sidebar-accounts-toggle, .js-settings-accounts-toggle, .js-settings-accounts-toggle a")) {
      return $(".js-sidebar-accounts, .js-settings-accounts-toggle").removeClass("accounts-open");
    }
  },

  toggle_accounts(evt) {
    if (!$(this).hasClass("js-new-account")) { evt.preventDefault(); }
    return $(this).closest(".js-sidebar-accounts").toggleClass("accounts-open");
  },

  toggle_panel(evt) {
    evt.preventDefault();
    return $(this).closest(".js-settings-panel").toggleClass("open");
  },

  toggle_settings_accounts(evt) {
    evt.preventDefault();
    return $(this).toggleClass("accounts-open");
  }
};